import { useQuery } from "@tanstack/react-query";

import { countryStorage } from "@/lib/storage/country";
import { apiGeo } from "@/services/api-client/geo";

import { geoKeys } from "./geo.keys";

export const useGetCountryCode = () => {
  const cached = countryStorage.get();

  return useQuery({
    queryKey: geoKeys.countryCode(),
    queryFn: async () => {
      const { country_code } = await apiGeo.getCountryCode();
      countryStorage.set(country_code);
      return country_code;
    },
    enabled: !cached,
    initialData: cached ?? undefined,
    staleTime: Number.POSITIVE_INFINITY,
  });
};
